import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import announcementsActions from '../../redux/announcements/actions';
import AnnouncementList from '../../components/AnnouncementList';
import SidebarContainer from '../SidebarContainer';
import './Announcements.scss';

class Announcements extends Component {
  componentDidMount() {
    this.props.actions.resetAnnouncement();
    this.props.actions.announcementsRequest();
  }

  getAnnouncement = async announcementId => {
    await this.props.actions.announcementRequest(announcementId);
  };

  render() {
    const { actions, announcements } = this.props;
    return (
      <SidebarContainer title="Announcements">
        <div className="announcements-table">
          <AnnouncementList
            list={announcements.announcements}
            error={announcements.error}
            fetching={announcements.fetching}
            onDelete={actions.deleteAnnouncementRequest}
            getAnnouncement={this.getAnnouncement}
          />
        </div>
      </SidebarContainer>
    );
  }
}

Announcements.propTypes = {
  announcements: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ announcements }) => ({ announcements });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...announcementsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Announcements);
